import React, { Component } from 'react';
import './App.scss';

import Nav from './Nav';
import Story from './Story';
import STORIES from './Story.const';

import headerTitle from './assets/images/header_title.png';
import headerImage from './assets/images/headerimage.jpg';
import playButton from './assets/images/top_playbutton.jpg';
import pauseButton from './assets/images/top_pausebutton.jpg';

if(window.location.pathname.substr(-1) == '/'){
	var root = window.location.pathname;
}else{
	var root = window.location.pathname+'/';
}
export const APP_ROOT_PATH = root;
//export const APP_ROOT_PATH = '/theheartseekers/';

class App extends Component {
  constructor(props) {
    super(props);

    const language = this.getLanguage();

    this.state = {
      language,
      activeAudioIndex: undefined
    };

    if (!language === '' || !this.isValidLanguage(language)) {
      window.location.href = `${APP_ROOT_PATH}/zh-HK`;
      return;
    }

    this.players = [];
    for (const _ of STORIES) {
      this.players.push(undefined);
    }
  }

  getLanguage = () => {
    let language = 'zh-HK';
    const { match } = this.props;
    /*if (match && match.params && match.params.language) {
      language = match.params.language;
    }*/
	if (match && match.url && match.url.split("/").pop() == 'en') {
      language = 'en';
    }else if (match && match.url && match.url.split("/").pop() == 'zh-hk') {
	  language = 'zh-HK';
	}
    return language;
  };

  isValidLanguage = language => {
    return ['en', 'zh-HK'].includes(language);
  };

  handlePlayClick = index => {
    const { players, pausePlayer } = this;
    const { activeAudioIndex } = this.state;

    if (activeAudioIndex !== undefined) {
      // pause playing audio
      pausePlayer(activeAudioIndex);
    }

    if (activeAudioIndex !== index) {
      // play selected audio
      let newPlayer = players[index];
      if (!newPlayer) {
        const soundTrack =
          this.getLanguage() === 'en'
            ? STORIES[index].soundTrackEN
            : STORIES[index].soundTrack;
        newPlayer = new Audio(soundTrack);
        newPlayer.addEventListener('ended', () => {
          this.setState({ activeAudioIndex: undefined });
        });
        players[index] = newPlayer;
      }
      newPlayer.play();
      this.setState({ activeAudioIndex: index });
    } else {
      // pause current audio
      this.setState({ activeAudioIndex: undefined });
    }
  };

  handlePlayIntroductionClick = () => {
    this.handlePlayClick(0);
  };

  pausePlayer = index => {
    const { players } = this;
    const oldPlayer = players[index];
    oldPlayer && oldPlayer.pause();
  };

  render() {
    const { handlePlayClick, handlePlayIntroductionClick } = this;
    const { language, activeAudioIndex } = this.state;

    return (
      <div className="wrapper">
        <Nav language={language}/>
        <section className="journey">
          <div className="stories">
            {STORIES.map((story, index) => {
              const { title, subTitle, imageSrc, desc, descEN } = story;

              return (
                <Story
                  key={index}
                  index={index}
                  title={title}
                  subTitle={subTitle}
                  desc={this.getLanguage()=='en'?descEN:desc}
                  imageSrc={imageSrc}
                  onPlayClick={handlePlayClick}
                  isPlaying={activeAudioIndex === index}
                />
              );
            })}
          </div>
		  
        </section>
      </div>
    );
  }
}

export default App;
